// SPDX-License-Identifier: AGPL-3.0-or-later

import {PioneerlandsMark} from '@app/features/app/components/layout/pioneer/PioneerlandsMark';
import styles from '@app/features/app/components/layout/pioneer/PioneerSidebar.module.css';

/** Mark, thin rule, then "Pioneer" with a red "chat", as on pioneerlands.org. */
export function PioneerWordmark() {
	return (
		<span className={styles.wordmark} translate="no" data-flx="app.pioneer.pioneer-wordmark.wordmark">
			<span className={styles.markBox} data-flx="app.pioneer.pioneer-wordmark.mark-box">
				<PioneerlandsMark data-flx="app.pioneer.pioneer-wordmark.pioneerlands-mark" />
			</span>
			<span className={styles.rule} aria-hidden="true" data-flx="app.pioneer.pioneer-wordmark.rule" />
			<span className={styles.wordmarkText} data-flx="app.pioneer.pioneer-wordmark.wordmark-text">
				<span data-flx="app.pioneer.pioneer-wordmark.span">Pioneer</span>
				<span className={styles.wordmarkAccent} data-flx="app.pioneer.pioneer-wordmark.wordmark-accent">
					chat
				</span>
			</span>
		</span>
	);
}
